<template>
  <h2 class="h2" :class="[noMarginTop ? 'h2-no-margin-top' : '']">
    <slot></slot>
  </h2>
</template>

<script>
export default {
  name: 'AfH2',
  props: {
    noMarginTop: {
      type: Boolean
    } 
  }
}
</script>

<style lang="postcss" scoped>
@import '../variables/custom-media.css';

.h2 {
  align-items: center;
  display: flex;
  font-size: 22px;
  font-weight: 600;
  color: #000000;
  line-height: 35px;
  margin-bottom: var(--spacing-third);
  margin-top: var(--spacing);

  @media (--bp-nis-medium) {
    font-size: 28px;
    line-height: 35px;  
  }
}

.h2-no-margin-top {
  margin-top: 0;
}


</style>



// WEBPACK FOOTER //
// src/components/AfH2.vue